import React from 'react';

import { faMailbox } from '@fortawesome/pro-regular-svg-icons';

import StrongTextField from '../components/StrongTextField';

export default {
  name: 'emails',
  title: 'Emails',
  icon: faMailbox,
  resource: 'leon_stockmail',
  primaryKey: 'idstockmail',
  sort: '-idstockmail',
  head: {
    idstockmail: 'ID',
    to: 'Destinataire',
    subject: 'Subject',
    date_envoi: 'Date',
    nbrelance: 'Relances',
  },
  list: ({ values }) => [values.idstockmail, values.to, values.subject, values.date_envoi, values.nbrelance],
  filter: ({ values, props }) => [
    <StrongTextField name='to' label='Destinataire' values={values.to} {...props} />,
    <StrongTextField name='subject' label='Subject' values={values.subject} {...props} />,
  ],
  remove: true,
};
